import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

export type Settings = number | string | boolean | { [property: string]: Settings } | Settings[];

export interface SettingsObject {
  [key: string]: Settings;
}

/**
 * This service will provide access to app constants & user defined
 * settings.
 */
@customElement('ltn-settings-service')
export class LtnSettingsService extends LitElement {
  protected __name = 'ltn-settings-service';

  protected _appConstants: SettingsObject = {};

  private __appSettings: SettingsObject = {};

  private __userSettings: SettingsObject = {};

  constructor() {
    super();

    const userSettings = localStorage.getItem(this.__name);
    if (userSettings) this.__userSettings = JSON.parse(userSettings);
  }

  setAppSettings(settings: SettingsObject) {
    this.__appSettings = settings;
    this.updated();
  }

  setUserSettings(settings: SettingsObject) {
    this.__userSettings = settings;
    localStorage.setItem(this.__name, JSON.stringify(this.__userSettings));

    this.updated();
  }

  updateUserSettings(settings: SettingsObject) {
    return this.setUserSettings({
      ...this.__userSettings,
      ...settings,
    });
  }

  updated() {
    // TODO: The event should contain the changes.
    this.dispatchEvent(new CustomEvent('settings-updated'));
  }

  get settings() {
    return {
      ...this.__appSettings,
      // TODO: Merge sub properties nicely
      ...this.__userSettings,
      ...this._appConstants,
    };
  }
}
